import * as React from "react";
import { singleton } from "logic/singleton";
const LogViewLayoutContext = React.createContext(void 0);
export default singleton("contexts.LogViewLayoutContext", () => LogViewLayoutContext);
